import { Component, OnInit, Input, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { Goal, GoalEdit } from '../model/goal';
import { NGXLogger } from 'ngx-logger';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { GoalService } from 'src/app/core/service/goal.service';
import { IntlService } from '@progress/kendo-angular-intl';
import { sortBy } from 'lodash';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { SettingService } from 'src/app/core/service/setting.service';

@Component({
  standalone: false,
  selector: 'app-goal-list',
  templateUrl: './goal-list.component.html',
  styleUrls: ['./goal-list.component.scss']
})
export class GoalListComponent implements OnInit
{
  @ViewChild('patientGoalCollapsible') public patientGoalCollapsible: any;
  @ViewChild('caseGoalCollapsible') public caseGoalCollapsible: any;
  @ViewChildren(TooltipDirective) public tooltipDir: QueryList<TooltipDirective>;

  @Input() public memberId: number;
  @Input() public caseId: number;

  public goals: any[] = [];
  public isNewGoal: boolean;
  public patientGoalCollapsed = false;
  public caseGoalCollapsed = false;
  public editDataItemGoal: GoalEdit;
  public patientLabel = {};

  constructor(
    private goalService: GoalService,
    private logger: NGXLogger,
    private messageHandlerService: MessageHandlerService,
    public intl: IntlService,
    private settingService: SettingService,)
  { }

  public ngOnInit(): void
  {
    this.settingService.getCachedSessionSettings().subscribe({
      next: (sessionSetting) =>
      {
        this.patientLabel = { patientLabel: sessionSetting.patientLabel };
      }
    });
    if (this.memberId !== null && this.memberId !== undefined)
    {
      this.goals = [];
      this.goalService.getGoalsByMember(this.memberId).subscribe({
        next: (data) =>
        {
          const goals = [];
          data.forEach(d =>
          {
            d.createdOn = new Date(d.createdOn);
            d.lastModifiedOn = new Date(d.lastModifiedOn);
            d.sort = this.goalService.setSort(d);
            goals.push(d);
          });
          this.goals = sortBy(goals, ['sort']);
        },
        error: (error) =>
        {
          this.logger.error(error);
        }
      });
    }
    else
        if (this.caseId !== null && this.caseId !== undefined)
        {
          this.goals = [];
          this.goalService.getGoalsByCase(this.caseId).subscribe({
            next: (data) =>
            {
              const goals = [];
              data.forEach(d =>
              {
                d.createdOn = new Date(d.createdOn);
                d.lastModifiedOn = new Date(d.lastModifiedOn);
                d.sort = this.goalService.setSort(d);
                goals.push(d);
              });
              this.goals = sortBy(goals, ['sort']);
            },
            error: (error) =>
            {
              this.logger.error(error);
            }
          });
        }
  }

  /**
   * Get the user and open the dialog of team details
   *
   * @param user User to send at the component
   */
  public openGoalEditDialog(goal: Goal): void
  {
    this.isNewGoal = false;
    setTimeout(() =>
    {
      this.goalService.getGoal(goal.id).subscribe({
        next: (aGoal) =>
        {
          const goalEdit = new GoalEdit();

          goalEdit.id = aGoal.id;
          goalEdit.memberId = aGoal.memberId;
          goalEdit.goal = aGoal.goal;
          goalEdit.type = aGoal.type;
          goalEdit.progress = aGoal.progress;
          goalEdit.actionPlan = aGoal.actionPlan;

          this.editDataItemGoal = goalEdit;
        }
      });
    });
  }

  public addGoal(): void
  {
    this.isNewGoal = true;
    setTimeout(() => { this.editDataItemGoal = new GoalEdit(); });
  }

  public onSaveGoal(goal: any): void
  {
    const goalToSave = new Goal();
    goalToSave.id = goal.id;
    goalToSave.memberId = goal.memberId;
    goalToSave.caseId = goal.caseId;
    goalToSave.goal = goal.goalText;
    goalToSave.goalId = goal.goalId;
    goalToSave.type = goal.typesOfGoal;
    goalToSave.progress = goal.progress;
    goalToSave.actionPlan = goal.actionPlan;

    this.goalService.saveGoal(goalToSave, this.isNewGoal, goalToSave.id).subscribe({
      next: (data) =>
      {
        this.messageHandlerService.displaySuccess(this.isNewGoal ? 'GOAL-CREATED-SUCCESFULLY' : 'GOAL-UPDATED-SUCCESFULLY');

        goalToSave.id = data.id;
        if (goal.id !== undefined)
        {
          this.goals = this.goals.filter(t => t.id !== data.id);
        }
        data.createdOn = new Date(data.createdOn);
        data.sort = this.goalService.setSort(data);
        this.goals.push(data);

        this.goals = sortBy(this.goals, ['sort']);
      },
      error: (error) =>
      {
        this.messageHandlerService.displayError(error);
        this.logger.error(error);
      }
    });
  }

  public onDeleteGoal(goal: GoalEdit): void
  {
    this.goalService.deleteGoal(Number(goal.id)).subscribe({
      next: () =>
      {
        this.messageHandlerService.displaySuccess('GOAL-DELETED-SUCCESFULLY');
        this.goals = this.goals.filter(t => t.id !== goal.id);
      },
      error: (error) =>
      {
        this.messageHandlerService.displayError(error);
        this.logger.error(error);
      }
    });
  }

  public goalToggle(): void
  {
    if (this.patientGoalCollapsible !== undefined)
    {
      this.patientGoalCollapsible.toggleChange();
    }
    if (this.caseGoalCollapsible !== undefined)
    {
      this.caseGoalCollapsible.toggleChange();
    }
  }

  public showTooltip(e: ElementRef, tooltip: ElementRef): void
  {
    const tooltipDirective = this.tooltipDir.toArray().find(t => t.tooltipWrapper.nativeElement === tooltip);
    if (tooltipDirective)
    {
      tooltipDirective.toggle(e, true); // Show the tooltip
    }
  }

  public hideTooltip(tooltip: ElementRef): void
  {
    const tooltipDirective = this.tooltipDir.toArray().find(t => t.tooltipWrapper.nativeElement === tooltip);
    if (tooltipDirective)
    {
      tooltipDirective.hide(); // hide the tooltip
    }
  }    
}
